import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetTags } from "api/generated/tags/tags";

import { CONTROL_LIST_QUERY_OPTIONS } from "./controlListQueryOptions";

export function useTagOverviewsQuery() {
    return useGetTags({
        query: {
            ...CONTROL_LIST_QUERY_OPTIONS,
            select: (response) => response.data,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
